const normalizeRole = (value) => {
  if (typeof value !== 'string') {
    return 'user';
  }

  const role = value.trim().toLowerCase();

  if (role.includes('admin')) {
    return 'admin';
  }

  return 'user';
};

export const getRoleFromLoginResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return 'user';
  }

  const directRole = data.role || data.userRole || data.type;
  const nestedRole = data.user?.role || data.user?.userRole || data.user?.type;

  if (typeof directRole === 'string') {
    return normalizeRole(directRole);
  }

  if (typeof nestedRole === 'string') {
    return normalizeRole(nestedRole);
  }

  if (typeof data.isAdmin === 'boolean') {
    return data.isAdmin ? 'admin' : 'user';
  }

  if (typeof data.user?.isAdmin === 'boolean') {
    return data.user.isAdmin ? 'admin' : 'user';
  }

  return 'user';
};

export const storeAuthRole = (role) => {
  localStorage.setItem('userRole', normalizeRole(role));
};

export const getStoredRole = () => normalizeRole(localStorage.getItem('userRole'));
